function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwCommandBar from 'viewmodel/AwCommandBarViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import { VisibleWhen, EnableWhen } from 'js/hocCollection';
const DivVisibleWhen = VisibleWhen('div');
const AwTextboxEnableWhen = EnableWhen(AwTextbox);
const AwTextareaEnableWhen = EnableWhen(AwTextarea);
DivVisibleWhen.displayName = 'DivVisibleWhen';
AwTextboxEnableWhen.displayName = 'AwTextboxEnableWhen';
AwTextareaEnableWhen.displayName = 'AwTextareaEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/dispatchService', () => import('js/dispatchService'));
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "name": {
      "displayName": "Label",
      "dbValue": "{{data.rfqDetails.name}}",
      "type": "STRING",
      "dispValue": "",
      "labelPosition": "NO_PROPERTY_LABEL"
    },
    "description": {
      "displayName": "Label",
      "dbValue": "{{data.rfqDetails.description}}",
      "type": "STRING",
      "dispValue": "",
      "labelPosition": "NO_PROPERTY_LABEL"
    },
    "descriptionEdit": {
      "displayName": "{{i18n.description}}",
      "type": "STRING",
      "dbValue": "{{data.rfqDetails.descriptionEdit}}",
      "displayValue": "{{data.rfqDetails.descriptionEdit}}",
      "isModifiable": "true",
      "isEditable": "true",
      "isEnabled": "true",
      "maxLength": 256,
      "renderingHint": "textbox",
      "labelPosition": "PROPERTY_LABEL_AT_TOP"
    },
    "dueDate": {
      "displayName": "{{i18n.dueDate}}",
      "type": "STRING",
      "dbValue": "data.rfqDetails.dueDate",
      "dispValue": ""
    },
    "dueDateEdit": {
      "displayName": "{{i18n.dueDate}}",
      "type": "STRING",
      "dbValue": "data.rfqDetails.dueDateEdit",
      "displayValue": "data.rfqDetails.dueDateEdit",
      "isRequired": "true",
      "isEditable": "true",
      "isEnabled": "true",
      "maxLength": 256,
      "labelPosition": "PROPERTY_LABEL_AT_SIDE"
    },
    "status": {
      "displayName": "{{i18n.status}}",
      "type": "STRING",
      "isEditable": "true",
      "dbValue": "data.rfqDetails.status.name",
      "dispValue": ""
    }
  },
  "actions": {
    "publishRfqStatusEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "rfq-status-event",
        "eventData": "{{parameters.eventData.status.name}}"
      },
      "deps": "js/rfqHelper"
    },
    "getRfqDetails": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqDetails( $collaborationspaceId: String, $rfqId: String) { getRfqDetails( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId)}",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "rfqDetails": "data.data.getRfqDetails"
      },
      "events": {
        "success": [{
          "condition": "rfqDetails.rfqId",
          "name": "get-rfq-details.success",
          "eventData": {
            "rfqDetails": "{{rfqDetails}}"
          }
        }, {
          "name": "updateRfqDetailLabels",
          "condition": "rfqDetails && rfqDetails.rfqId",
          "eventData": {
            "eventName": "updateRfqDetailLabels",
            "eventData": "{{rfqDetails}}"
          }
        }, {
          "condition": "rfqDetails.error.statusCode === 400 || errorCode === 400",
          "name": "get-rfq-details.error",
          "eventData": {
            "error": "{{rfqDetails.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqDetails.error.statusCode === 403 || errorCode === 403",
          "name": "get-rfq-details.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "rfqDetails.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "get-rfq-details.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "rfqDetails.error.statusCode >= 500 && rfqDetails.error.statusCode <= 599",
          "name": "get-rfq-details.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "get-rfq-details.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "updateRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation updateRfq( $collaborationspaceId: String, $rfqId: String, $updateRfqInput: Json) { updateRfq( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, updateRfqInput: $updateRfqInput ) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}",
              "updateRfqInput": {
                "name": "{{data.nameEdit.dbValue}}",
                "description": "{{data.descriptionEdit.dbValue}}",
                "dueDate": "{{data.dueDateEdit.dbValue}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "rfqUpdated": "data.data.updateRfq"
      },
      "events": {
        "success": [{
          "condition": "rfqUpdated.rfqId",
          "name": "update-rfq.success",
          "eventData": {
            "rfqUpdated": "{{rfqUpdated}}"
          }
        }, {
          "condition": "rfqUpdated.rfqId",
          "name": "cancelEditEvent"
        }, {
          "condition": "rfqUpdated.rfqId",
          "name": "refreshRfqDetails"
        }, {
          "condition": "rfqUpdated.error === 'EMPTY_COLLAB_SPACE'",
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqUpdated.error.statusCode === 400 || errorCode === 400",
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{rfqUpdated.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "rfqUpdated.error.statusCode === 403 || errorCode === 403",
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "rfqUpdated.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "rfqUpdated.error.statusCode >= 500 && rfqUpdated.error.statusCode <= 599",
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "update-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "updateRfqDetailLabelsAction": {
      "actionType": "JSFunction",
      "method": "updateRfqDetailLabelsFunction",
      "inputData": {
        "data": "{{data}}",
        "jobDetails": "{{parameters.eventData}}"
      },
      "deps": "js/dispatchService"
    },
    "addStartEditToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "enableEditRfq",
        "value": true
      }
    },
    "addCancalEditToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "enableEditRfq",
        "value": false
      }
    }
  },
  "onEvent": [{
    "eventId": "updateRfqDetailLabelsConsolidateView",
    "action": "getRfqDetails",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "updateRfqDetailLabels",
    "action": "updateRfqDetailLabelsAction",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "get-rfq-details.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-get-rfq-details.success",
      "eventData": "{{eventData.rfqDetails}}"
    }
  }, {
    "eventId": "get-rfq-details.success",
    "action": "publishRfqStatusEvent",
    "inputArgs": {
      "eventData": "{{eventData.rfqDetails}}"
    }
  }, {
    "eventId": "get-rfq-details.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-get-rfq-details.error",
      "eventData": "{{eventData.error}}"
    }
  }, {
    "eventId": "startEditEvent",
    "action": "addStartEditToCtx",
    "cacheEventData": true
  }, {
    "eventId": "cancelEditEvent",
    "action": "addCancalEditToCtx",
    "cacheEventData": true
  }, {
    "eventId": "saveEditEvent",
    "action": "updateRfq",
    "cacheEventData": true
  }, {
    "eventId": "update-rfq.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-update-rfq.success",
      "eventData": "{{eventData.rfqUpdated}}"
    }
  }, {
    "eventId": "refreshRfqDetails",
    "action": "getRfqDetails",
    "cacheEventData": true
  }, {
    "eventId": "update-rfq.success",
    "message": "updateSuccess"
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "onInit": "getRfqDetails",
    "onMount": "addCancalEditToCtx"
  },
  "conditions": {
    "enableEditRfqCondition": {
      "expression": "ctx.enableEditRfq"
    }
  },
  "messages": {
    "updateSuccess": {
      "messageType": "INFO",
      "messageText": "RFQ got updated successfully."
    }
  },
  "i18n": {
    "name": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "description": ["RfqMessages"],
    "status": ["RfqMessages"],
    "quoteName": ["RfqMessages"],
    "rfqDetails": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "saveRfq": ["RfqMessages"]
  },
  "_viewModelId": "GetRfqDetails",
  "_uniqueViewModelId": "GetRfqDetails",
  "ctx": {
    "rfq": {
      "type": "object"
    },
    "enableEditRfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <aw-panel>
        <aw-panel-body>
            <aw-flex-column>
                <div visible-when="!conditions.enableEditRfqCondition">
                    <!-- Read Only -->
                    <table>
                        <tr>
                            <td class="displayInlineFlex">
                                <aw-label prop="data.name" class="rfqHeader label-without-property"></aw-label>
                                <aw-command-bar show-command-labels="true" anchor="editRfqSidenavPushCommandAnchor"
                    alignment="HORIZONTAL"></aw-command-bar>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><aw-label prop="data.description" class="alignLeft label-without-property"></aw-label></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <h4>
                                <td class="rfqDetailsWidth"><aw-label prop="data.dueDate" class="propertyDisplay"></aw-label></td>
                            </h4>
                            <h4>
                                <td class="rfqDetailsWidth"><aw-label prop="data.status" class="propertyDisplay"></aw-label></td>
                            </h4>
                            <td></td>
                        </tr>
                    </table>
                </div>

                <div visible-when="conditions.enableEditRfqCondition">
                    <!-- Edit Mode On -->
                    <table>
                        <tr>
                            <td class="displayInlineFlex">
                                <aw-label prop="data.name" class="rfqHeader label-without-property"></aw-label>
                                <aw-command-bar show-command-labels="true" anchor="editRfqSidenavPushCommandAnchor"
                    alignment="HORIZONTAL"></aw-command-bar>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><aw-textbox enable-when="conditions.enableEditRfqCondition" prop="data.nameEdit"
                                    alignment="HORIZONTAL"></aw-textbox></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><aw-textarea enable-when="conditions.enableEditRfqCondition" prop="data.descriptionEdit"
                                    alignment="HORIZONTAL"></aw-textarea></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><aw-textbox prop="data.dueDateEdit"></aw-textbox></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td><aw-label prop="data.status"></aw-label></aw-textbox></td>
                            <td></td>
                        </tr>
                        <tr></tr>
                    </table>
                </div>
            </aw-flex-column>
        </aw-panel-body>
    </aw-panel>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(AwPanelBody, null, /*#__PURE__*/React.createElement(AwFlexColumn, null, /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("!conditions.enableEditRfqCondition")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("h4", null), /*#__PURE__*/React.createElement("h4", null), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "displayInlineFlex"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.name", fields, $index, null, null), {
    className: "rfqHeader label-without-property"
  })), /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "editRfqSidenavPushCommandAnchor",
    alignment: "HORIZONTAL"
  })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.description", fields, $index, null, null), {
    className: "alignLeft label-without-property"
  }))), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "rfqDetailsWidth"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.dueDate", fields, $index, null, null), {
    className: "propertyDisplay"
  }))), /*#__PURE__*/React.createElement("td", {
    className: "rfqDetailsWidth"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.status", fields, $index, null, null), {
    className: "propertyDisplay"
  }))), /*#__PURE__*/React.createElement("td", null))))), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.enableEditRfqCondition")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "displayInlineFlex"
  }, /*#__PURE__*/React.createElement(AwLabel, _extends({}, getField("data.name", fields, $index, null, null), {
    className: "rfqHeader label-without-property"
  })), /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "editRfqSidenavPushCommandAnchor",
    alignment: "HORIZONTAL"
  })), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextboxEnableWhen, _extends({}, getField("data.nameEdit", fields, $index, null, null), {
    alignment: "HORIZONTAL",
    enableWhen: AwParseService.instance("conditions.enableEditRfqCondition")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextareaEnableWhen, _extends({}, getField("data.descriptionEdit", fields, $index, null, null), {
    alignment: "HORIZONTAL",
    enableWhen: AwParseService.instance("conditions.enableEditRfqCondition")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextbox, getField("data.dueDateEdit", fields, $index, null, null))), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwLabel, getField("data.status", fields, $index, null, null))), /*#__PURE__*/React.createElement("td", null)), /*#__PURE__*/React.createElement("tr", null))))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;